import { useContext, useEffect, useState } from "react";
import Page from "../Page";
import { useAccess } from "src/hooks/useAccess.hook";
import { Card, Stack } from "@mui/material";
import { BaseTable } from "../BaseTable/BaseTable";
import { useList } from "src/hooks/useFetch.hook";
import { FEATURE } from "src/util/enums";
import { companyListColumns } from "./company.constants";
import { useNavigate } from "react-router-dom";
import { CommonSearchbar } from "src/layouts/dashboard/Searchbar";
import { Context } from "src/context";

export const CompanyList = () => {
  const navigate = useNavigate()
  const { timezone } = useContext(Context);
  const hasCreateAccess = useAccess(FEATURE.COMPANY, "C");
  const isReadOnly = useAccess(FEATURE.COMPANY, "R");
  const { data: company, isFetching } = useList("companyList");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (!isFetching) {
      setTableData(company ?? []);
    }
  }, [isFetching, company]);

  const handleSearching = (event) => {
    const searchValue = event.target.value.trim().toLowerCase();
    if (searchValue) {
      setTableData(
        (company ?? []).filter((row) =>
          (row.name ?? "").toLowerCase().includes(searchValue)
        )
      );
    } else {
      setTableData(company ?? []);
    }
  };

  const rowOrCellClickRedirect = ({ id }) => {
    // if(isReadOnly) return;
    navigate(`/company/${id}`);
  };
    const pageActions = isReadOnly
      ? []
      : [{ path: "/company/new", text: "Add Company", icon: "eva:plus-fill" }];
    const showOcpiOnboardingButton = !isReadOnly;

    return (
    <Page
      title="Company | Smart-CMS"
        actions={pageActions}
      hasCreateAccess={hasCreateAccess}
        showOcpiOnboardingButton={showOcpiOnboardingButton}
        ocpiOnboardingText={"OCPI Onboarding"}
    >
      <Card sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="flex-end" mb={2}>
          <CommonSearchbar placeholder="Search by company name" searchFunc={handleSearching} />
        </Stack>
        <BaseTable
          rows={tableData}
          columns={companyListColumns(isReadOnly, timezone.timezone?.value)}
          loading={isFetching}
          getRowId={(row) => row.teamId}
          rowOrCellClickRedirect={rowOrCellClickRedirect}
          isReadOnly={isReadOnly}
        />
      </Card>
    </Page>
  );
};
